import scope from 'recompose-scope/composeWithScope'
import exposeProps from 'recompose-scope/exposeProps'

import withHandlers from 'recompose/withHandlers'


import EditorView from './Editor'


const Editor = scope(

  // x-uiSetting
  withHandlers({
    printStatement: () => {
      window.print()
    },
  }),

  exposeProps([
    'printStatement',
    'ui',
  ]),
)(EditorView)

Editor.displayName = 'StatementViewer'

export default Editor



// WEBPACK FOOTER //
// ./src/components/Statement/index.js